import { request } from '../request'

// 获取任务详情
export interface GetTaskDetail {
  task_id: string
  result_id: string
}
export const getTaskDetail = (data: GetTaskDetail) =>
  request('/portal/verify/dataProtection/resultInfo', {
    params: data,
  })

// 获取任务详情文件列表
export interface GetResource {
  task_id: string
  result_id: string
  file_format?: string //1:txt;2:doc;3:pdf
  compress_type?: string //1:zip;2:7z;3:tar;4:gz;5:zip加密;6:7Z加密;7:tar加密;8:gz加密
  protect_status?: string | number //1:成功；2:失败
  leak_type?: string //1:HTTP;2:HTTPS;3:GIT
}
export const getResource = (data: GetResource) =>
  request('/portal/verify/dataProtection/resultResourceList', {
    params: data,
  })

// 修改拦截状态
export const updateInterceptStatus = data =>
  request(`/portal/verify/dataProtection/result/resourceIntercept/${data.id}`, {
    method: 'PUT',
    data: data.list,
  })
